var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"surroundContainer"},[_vm._m(0),_c('div',{staticClass:"chart-box"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"unit"},[_vm._v(" 单位： "+_vm._s(_vm.unit)+" ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"title"},[_vm._v("秸秆收纳总量分析")])])
}]

export { render, staticRenderFns }